import React from 'react';

const LoadingSpinner = () => {
  return (
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  );
};

export default LoadingSpinner;
